import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string().email('signup.form.error.email_1').required('signup.form.error.email_2')
});
